/**
 * App Icon Badge (Badging API)
 * Shows an unread-count dot/number on the installed PWA's home-screen icon.
 * Supported on Android Chrome and desktop Chrome/Edge; no-op elsewhere.
 */

type NavigatorWithBadge = Navigator & {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

export function updateAppBadge(unreadCount: number): void {
  const nav = navigator as unknown as NavigatorWithBadge;
  if (!nav.setAppBadge || !nav.clearAppBadge) return;

  const action = unreadCount > 0 ? nav.setAppBadge(unreadCount) : nav.clearAppBadge();
  action.catch(() => {});
}
